import React from 'react';
import Warehouse from "./Warehouse";
import PropTypes from "prop-types";

const WarehousesList = props => (
    <table className="table table-bordered table-striped table-hover text-center main-table list-table warehouse-table">
      <thead>
      <tr>
        <th scope="col">ID</th>
        <th scope="col">Warehouse name</th>
        <th scope="col">Working hours</th>
        <th scope="col">Dockers</th>
        <th scope="col">Actions</th>
      </tr>
      </thead>
      <tbody>
      {props.warehouses.map((warehouse, index) => (<Warehouse key={warehouse.id} warehouse={warehouse} index={index} deleteWarehouse={props.deleteWarehouse}/>))}
      </tbody>
    </table>
);

WarehousesList.propTypes = {
  warehouses: PropTypes.array.isRequired,
  deleteWarehouse: PropTypes.func.isRequired
};

export default WarehousesList;



// WEBPACK FOOTER //
// ./src/components/WarehousesList/WarehousesList.jsx